export default __webpack_public_path__ + "static/media/bg_01.fa7fcf25.jpg";